import { styled } from "@mui/material";
import { TaskSquare, DollarCircle } from "iconsax-react";

export const Logo = styled("img")(() => ({
  width: "160px",
  height: "auto",
}));

export const TaskSquareIcon = styled(TaskSquare)(() => ({}));

export const DollarCircleIcon = styled(DollarCircle)(() => ({}));
